/* eslint-disable */
import axios from "axios";

export default {
  methods: {
    /**
     * Faz o put do questionario completo de Centro de Hemodinamica
     */
    putCentroHemodinamica(dados) {
      return axios.put(
        this.CriarUrl({
          resource: `questionario`
        }),
        dados
      );
    },
    /**
     * Faz o post do questionario completo de Centro de Hemodinamica
     * @param {Number} idRnpPrestador
     */
    postCentroHemodinamica(id, dados) {
      return axios.post(
        this.CriarUrl({
          resource: `questionario/${id}`
        }),
        dados
      );
    },
    /**
     * Faz o upload do arquivo
     * @param {FormData} formData
     * @param {Number} idRnpPrestador
     */

    putUploadArquivo(formData, campo, onProgress) {
      return axios.put(
        this.CriarUrl({
          resource: `${campo}/arquivos`
        }),
        formData,
        {
          onUploadProgress(progressEvent) {
            let porcentagem = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );

            if (onProgress) onProgress(porcentagem);

            return porcentagem;
          }
        }
      );
    },
    /**
     * Faz o put do questionario completo de Aps
     */
     putAps(id, dados) {
      if (!id) {
        return axios.put(
          this.CriarUrl({
            resource: `aps/questionario/0`
          }),
          dados
        );
      }
      return axios.put(
        this.CriarUrl({
          resource: `aps/questionario/${id}`
        }),
        dados
      );
    },
    getAps(id) {
      return axios.get(
        this.CriarUrl({
          resource: `aps/questionario/${id}`
        })
      );
    },
  }
};